import { AxiosResponse } from 'axios'
import { TaggersDailyProgressReportResponse } from '../shared/models'
import { post } from './base/base-http-service'

export const listCountryStatisticsReportService = async (
  payload
): Promise<AxiosResponse<TaggersDailyProgressReportResponse>> => {
  return post(`country-statistics-report`, payload)
}
